<span [ngClass]="'badge-outline-' + color" class="badge rounded py-0">
    <fa-icon [fixedWidth]="true" [icon]="['far', icon]" class="mr-1"></fa-icon>
    {{ label }}
</span>
